import { axiosMM } from "./axiosCreator";
import { NEARBY_PLACES_API } from "./constants";
import { decamelize } from "./utils";

/**
 * Retorna Array de trechos com os melhores preços de cada dia
 * @param {Object} options Objeto que personaliza query string de acordo com opções da API
 */
export const getNearbyAirports = options => {
	const query = Object.keys(options).reduce(
		(str, opt, i, self) =>
			`${str}${decamelize(opt)}=${options[opt]}${self.length - 1 == i ? "" : "&"}`,
		""
	);

	return axiosMM.get(`${NEARBY_PLACES_API}/airports?${query}`);
};

const get = query => axiosMM.get(`${NEARBY_PLACES_API}/airports/term/${query}`);

export default get;
